<!--

NOTA FISCAL DE ENTRADA - IMPORTACAO DE XML

QUANDO FOR UMA IMPORTACAO DE XML, RECEBE DA ROTINA "BO_NFS.NF_IMPORTNFE" OS PARAMETROS ABAIXO:
        params {
            codnf: NNN,
            importXml: Boolean,    // importacao de xml de nfe
            importResponse: { consumo: true, duplicatas: true, devolucao: true },
        }

        - consumo - indica que o xml é consumo final
        - duplicatas - indica que é uma venda
        - devolucao - indica que é devolucao de venda


nftix.cfop -> se existir mais de 1
- gerar array com cfop, codnates, cfopentrada
- atribuir o codnates para todos os itens





            if ((this.nf.stnf == '11' || this.nf.stnf == '01') && this.nf.flagarmazenada == 'S') {
                act = { action: 20, label: 'Excluir Armazenamento' }
                this.moreActions.push(act)
            }





-->

<script>
import { SysVars } from '../main';
import { arr, calcDesconto } from '../shared/numbers'
import { getText, formatDate, formatValue } from '../shared/utils'
import { apiORDSpost, apiORDSdelete, apiAutNFe, apiDownloadPDF, apiDownload } from '../shared/api-functions'
import nfFormRef from './nf-form-ref'
import ItemForm from './item-form'
import UnimedForm from './unimed-form'
import EstoqueEntrada from '../forms-estoque/estoque-entrada'
import nfeEventosForm from "./nfe-eventos-form";

export default {
  props: {
    params: {},
    crud: '',
  },

  components: {
    nfFormRef, ItemForm, UnimedForm, EstoqueEntrada, nfeEventosForm
  },

  data() {
    return {
      view: false,                //variavel para controle de visualizacao ou edicao
      formCab: false,             //editando cabecalho da nf
      formPar: false,             //editando parcelas da nf
      formIncluir: false,         //exibe formulario para inclusao de notas (campos participante e natureza)
      nfOutrasSaidas: false,      //inclusao de outras notas de saida
      showFormItem: false,        //exibe o formulario de manutencao de item do pedido
      showItemForm: false,        //exibe o formulario de cadastro de produto para inclusao
      showUnimedForm: false,        //exibe o formulario de unidade de medida para inclusao
      showCancel: false,          //exibe a justificativa do cancelamento
      showEventos: false,
      showCorrecao: false,        //exibe a tela para emissao da carta de correção
      showNfRef: false,           //exibe a inclusao de notas referenciadas - digitado pelo usuario
      formItemView: false,
      msgCancelItem: false,

      showFormImportXML: true,  // formulario para importacao de xml

      updateItem: false, //indica quando for uma alteracao de item

      //entidades
      nf: { ...this.$store.getters.getEntities.nf },
      nfit: [],
      nfpar: [],  //parcelas da nf
      nfref: [],  //notas referenciadas
      _nf: {},    //objeto utilizado para funcionalidade do botao descartar

      cfop_natureza: [],

      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [],  //armazena as mensagens de validacao da nf apos a gravacao
      textocorrecao: '',
      textocorrecao_anterior: '',
      errCorrecao: [],

      codpedv: 0,
      codnf: 0,

      codpart: 0, //codigo do participante para alteracao
      crudItem: '',  //inclusao de item
      transportadora: false,

      nfit_update: {},
      paramItem: {},

      moreActions: [],  //botao mais acoes

      tabs: [
        { title: 'Produtos' },
        { title: 'Outros Dados' },
        { title: 'Dados de Pagamento' },
        { title: 'Total' }
      ], //paginas
      activeTab: 0, //pagina ativa

      unwatch: true,
      changedItemIdx: 0,

      paramsCadastro: {},

      showFormEstoqueEntrada: false,
      excluirArmazenamento: false,

    }
  },

  computed: {
    isView: function () {
      // Alinhado com bar-grid: permite edição se stnf < '10' (diferente de '02') ou se stnf == '50'
      if (this.view)
        return true
      else
        return !((this.nf.stnf < '10' && this.nf.stnf != '02') || this.nf.stnf == '50')
    },

    entradaArmazenamentoPendente: function () {
      //habilitar e mostrar mensagem para efetuar armazenamento da nota
      if (this.nf.stnf == '03')
        return 'Efetue o armazenamento do estoque da nota de entrada.'
      else
        return null
    },

    partList: function () {
      return this.$store.getters.getPartList[0]
    },

    parcelas: function () {
      return this.nf.parcelas
    },

    stnf: function () {
      return getText(this.nf.stnf, this.metadata.nf.stnf)
    },

    title: function () {
      if (this.nf.entradaarmazenamento == 'S') {
        return 'Nota Fiscal de Entrada Armazenamento'
      }
      if (this.nf.operacaonf == 'E' && this.nf.stnf == '00' && this.nf.impxml == 'S') {
        return 'Concluir Importação do XML de Entrada '
      }
      else
        if (this.nf.operacaonf == 'E') {
          return 'Nota Fiscal de Entrada '
        }
    },

    nates: function () {
      if (this.nf.nates && this.nf.nates.length > 0) {
        return this.nf.nates[0]
      } else {
        return null
      }
    },

    codnates: function () {
      return this.nf.codnates
    },

    selectedNates: function () {
      return this.$store.getters.getNates
    },

    selectedItem: function () {
      return this.$store.getters.getItemList
    },

    _nomeuf: function () {
      if (this.nf.part) {
        if (this.nf.part[0].nomeuf) {
          return this.nf.part[0].nomeuf
        } else if (this.nf.part[0].estado) {
          return this.nf.part[0].estado[0].nomeuf
        }
      }
    },

    _nomemun: function () {
      if (this.nf.part) {
        if (this.nf.part[0].nomemun) {
          return this.nf.part[0].nomemun
        } else if (this.nf.part[0].mun) {
          return this.nf.part[0].mun[0].nomemun
        }
      }
    },

    _cnpjcpf: function () {
      //FORMATACAO DO CNPJ DO CLIENTE
      let doc = ''
      if (this.nf.part) {
        doc = this.nf.part[0].cnpjcpf
      }
      if (String(doc).length > 11) {
        doc = this.$formatCNPJ(doc)
      } else if (String(doc).length == 11) {
        doc = this.$formatCPF(doc)
      }
      return doc
    },

  },

  filters: {
    format: function (value, decimals) {
      return formatValue(value, decimals)
    },
  },

  methods: {
    itemChange(idx) {
      //CARREGA A UNIDADE DE MEDIDA QUANDO USUARIO ALTERAR O ITEM

      if (this.unwatch) {
        return
      }

      if (this.nfit[idx].coditem != null) {
        this.changedItemIdx = idx  //GUARDA O INDEX DO ITEM QUE FOI ALTERADO
        this.$store.dispatch('loadItem', { id: this.nfit[idx].coditem })
      }

    },

    unidadeItemChange(idx) {
      //HABILITA O CAMPO DE FATOR QUANDO ALTERADA A UNIDADE DE MEDIDA DO ITEM PARA UMA UNIDADE NAO RELACIONADA AO ITEM
      if (this.unwatch) {
        return
      }
      if (!this.nfit[idx]) {
        return
      }

      if (!this.nfit[idx].item[0]) {
        return
      }


      if (!this.nfit[idx].uni) {
        return
      }

      if (!this.nfit[idx].item[0].uni) {
        return
      }

      //SE A UNIDADE INFORMADA FOR IGUAL À UNIDADE DO ITEM
      if (this.nfit[idx].uni == this.nfit[idx].item[0].uni) {
        this.nfit[idx].fator = 1
        this.nfit[idx].obrigaFator = false
        return
      } else
        //SE NAO EXISTIR NENHUMA UNIDADE ALTERNATIVA
        if (!this.nfit[idx].item[0].itemum.length) {
          this.nfit[idx].obrigaFator = true
          this.nfit[idx].fator = 0
          return
        }

      //PROCURA A UNIDADE INFORMADA NA UNIDADE ALTERNATIVA DO ITEM
      let unidadeValida = false
      for (let i = 0; i < this.nfit[idx].item[0].itemum.length; i++) {
        if (this.nfit[idx].item[0].itemum[i].uni == this.nfit[idx].uni) {
          unidadeValida = true
          break;
        }
      }

      if (!unidadeValida) {
        this.nfit[idx].fator = 0
        this.nfit[idx].obrigaFator = true
      } else {
        this.nfit[idx].obrigaFator = false
      }

    },

    closeForm() {
      if (this.$route.params && this.$route.params.id)
        this.$router.go(-1)
      else
        this.$emit('closeform')
    },

    data(value) {
      return formatDate(value)
    },

    handleIncluirItem(idx) {
      //abre tela para cadastro de novo produto
      this.changedItemIdx = idx //GUARDA O INDICE DO ITEM DA NF

      this.crudItem = SysVars.crudI
      this.paramsCadastro = {}
      this.paramsCadastro.codigoxml = this.nfit[idx].nfitx[0].codigoxml
      this.paramsCadastro.descricao = this.nfit[idx].nfitx[0].descricao
      this.paramsCadastro.uni = this.nfit[idx].nfitx[0].uni
      this.paramsCadastro.ncm = this.nfit[idx].nfitx[0].ncm
      this.paramsCadastro.cest = this.nfit[idx].nfitx[0].cest
      this.paramsCadastro.orimerc = this.nfit[idx].nfitx[0].orimerc
      this.paramsCadastro.cean = this.nfit[idx].nfitx[0].cean
      if (this.selectedNates) {
        this.paramsCadastro.nates = this.selectedNates
      } else {
        this.paramsCadastro.nates = this.nates
      }
      this.paramsCadastro.coditem = null
      this.showItemForm = true
    },

    closeItemForm(item) {
      //ao fechar o formulario de cadastro de produto
      this.showItemForm = false

      //SE UM NOVO ITEM FOI CRIADO, CARREGA O CODIGO DO ITEM CRIADO PARA O ITEM DA NF
      if (item) {
        this.nfit[this.changedItemIdx].coditem = item.coditem
      }
    },

    handleIncluirUnimed(idx) {
      //abre tela para inclusao de unidade de medida
      this.changedItemIdx = idx //GUARDA O INDICE DO ITEM DA NF

      this.crudItem = SysVars.crudI
      this.paramsCadastro = {}
      this.paramsCadastro.uni = this.nfit[idx].nfitx[0].uni
      this.showUnimedForm = true
    },

    closeUnimedForm(uni) {
      //ao fechar o formulario de cadastro de unidade de medida
      this.showUnimedForm = false

      //SE UMA NOVA UNIDADE FOI CRIADA, CARREGA O CODIGO PARA O ITEM DA NF
      if (uni) {
        this.nfit[this.changedItemIdx].uni = uni.uni
      }
    },

    handleActions(action) {
      //cancela a nota fiscal
      if (action == 3) {
        this.showCancel = true
        this.$nextTick(function () {
          this.$refs.obscan.focus()
        })
      }

      //exclui a nota fiscal
      if (action == 5) {
        this.apiInvoiceDelete()
      }

      //download do xml
      if (action == 6) {
        this.downloadXML()
      }

      if (action == 30) {
        this.showEventos = true
      }

    },

    handleCancel() {
      //botao confirmacao de cancelamento da nf
      if (this.nf.obscan == null) {
        this.$erpToastError('Por favor preencha a justificativa para continuar')
        return
      }
      this.apiInvoiceCancel()
    },

    handleCancelDiscard() {
      //botao descartar cancelamento da nf
      this.showCancel = false
    },

    validaRef() {
      //efetua a validacao das notas referenciadas
      if (!this.showNfRef) {
        return true
      }
      if (this.nfref.length == 0) {
        this.$erpToastError('A Configuração da natureza de operação utilizada (' + this.nf.cfop + ') exige que seja referenciada uma chave.')
        return false
      }
      let erro = false
      for (let i = 0; i < this.nfref.length; i++) {
        this.nfref[i].validation = {}
        if (this.nfref[i].nfreftp == 1 || this.nfref[i].nfreftp == 2) {
          if (this.nfref[i].chave == null || this.nfref[i].chave.length < 44) {
            this.nfref[i].validation.chave = 'Chave inválida'
            erro = true
          }
        } else
          if (this.nfref[i].nfreftp == 3 || this.nfref[i].nfreftp == 4) {
            if (this.nfref[i].nf == null || this.nfref[i].nf.length < 1) {
              this.nfref[i].validation.nf = 'Número da NF obrigatório'
              erro = true
            }
          }
      }
      if (erro) {
        this.$erpToastError('Por favor preencha corretamente os campos em destaque para continuar')
      }
      return !erro

    },

    handleDescartar() {


    },

    handleSalvarDados() {
      //botao salvar dados do cabecalho da nf

    },

    handleConcluirImportXml() {
      //BOTAO PARA CONCLUIR DIGITACAO DA NF DE ENTRADA
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$scrollTo(0)
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          this.apiImportXML(true)
        }
      })
    },

    async apiImportXML(finalizar) {
      //efetua a gravacao da identificacao dos itens da importacao do xml da nf de entrada
      if (finalizar) {
        this.nf.stnf = '11' //entrada concluída
      }

      this.nf.nfit = this.nfit
      this.nf.nfpar = this.nfpar
      var sendData = { nf: this.nf }

      const data = await apiORDSpost(this.$store, 'invoice/importxml/', sendData, 'put')
      if (data.items) {
        this.nf = {}
        this.nfit = []
        this.nf = data.items[0]
        this.nf.nfit = data.items[0].nfit
        for (var x = 0; x < this.nf.nfit.length; x++) {
          this.nfit.push(this.nf.nfit[x])
        }
        for (let i = 0; i < this.nfit.length; i++) {
          this.unidadeItemChange(i);
        }

        let validation = JSON.parse(this.nf.validation)
        if (this.nf.validation && validation.errmessages) {
          this.errmessages = validation
          this.$scrollTo(0)
          this.$erpToastError('Por favor corrija os erros em destaque para esta nota fiscal')
        } else {
          this.errmessages = []
        }
      }
      this.updateActions()

      //console.log(this.nf.nfit[0].nfitx[0].msg)

      if (this.nf.import_errors > 0) {
        this.$scrollTo(0)
        this.$erpToastError('Por favor corrija os erros em destaque para esta nota fiscal')
      } else
        if (this.nf.stnf == '11') {
          this.$erpToastSuccess('A nota fiscal foi concluída')
          this.closeForm()
        }
    },

    async apiInvoiceDelete() {
      //exclui a nota fiscal
      var modulo = 'invoice/nf/' + this.nf.codnf
      await apiORDSdelete(this.$store, modulo)
      this.$erpToastSuccess('A Nota fiscal foi excluída com sucesso.')
      this.$emit('closeform')
    },

    async apiItens(nfIt) {
      //efetua a gravacao dos itens do pedido
      this.nf.nfit = { ...this.nfit }
      var sendData = {}
      sendData = { nf: this.nf } //pega o cabecalho da nf
      if (nfIt.length) {
        sendData.nf.nfit = nfIt //adiciona os novos itens ao cabecalho
      } else {
        sendData.nf.nfit = []
        sendData.nf.nfit.push(nfIt)
      }

      var metodo = 'post'
      // if (this.updateItem){
      // metodo = 'put'
      // }

      var modulo = 'invoice/nfit/'

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (data.items) {
        this.nf = data.items[0]
        this.nfit = data.items[0].nfit
        this.$erpToastSuccess('Item alterado com sucesso.')
        let validation = JSON.parse(this.nf.validation)
        if (this.nf.validation && validation.errmessages) {
          this.errmessages = validation
        } else {
          this.errmessages = []
        }
      }

      this.updateItem = false
    },

    closeFormItem() {
      //fecha tela de inclusao de item
      this.showFormItem = false
    },

    handleIncluirItemNF(nSeq, view) {
      //incluir item na nf

      this.nfit_update = { ...this.$store.getters.getEntities.nfit }
      this.nfit_update.finalidade = this.nf.finalidade
      this.nfit_update.codnf = this.nf.codnf
      //ajusta os parametros para chamada da tela de item da nf
      let nfAjuste = this.nf.tpnf == 'A'
      let nfComplementar = this.nf.tpnf == 'C'
      let optSimples = this.nf.filial[0].crt == '1' || this.nf.filial[0].crt == '4'
      this.paramItem = {
        nfit: this.nfit_update,
        nfAjuste: nfAjuste,
        nfComplementar: nfComplementar,
        habilitaItem: this.nfOutrasSaidas,
        optSimples: optSimples
      }
      //
      this.formItemView = false //indica se é alteração ou somente visualizacao
      this.updateItem = false
      this.showFormItem = true
    },

    handleEditItem(nSeq, view) {
      //editar o item da nf
      this.nfit_update = {}

      //localiza o item para alteracao atraves da sequencia
      for (var x = 0; x < this.nfit.length; x++) {
        if (this.nfit[x].itnf == nSeq) {
          this.nfit_update = { ...this.nfit[x] }
        }
      }

      //ajusta os parametros para chamada da tela de item da nf
      let nfAjuste = this.nf.tpnf == 'A'
      let nfComplementar = this.nf.tpnf == 'C'
      this.paramItem = { nf: this.nf, nfit: this.nfit_update, nfAjuste: nfAjuste, nfComplementar: nfComplementar, isView: view }
      //
      this.formItemView = view //indica se é alteração ou somente visualizacao
      this.updateItem = true
      this.showFormItem = true
    },

    handleCloseMessage() {
      this.msgCancelItem = false;
    },

    updateActions() {
      this.moreActions = []
      var act = {}
      if (this.nf.emissaopropria == 'S' && this.nf.stnf == '11') {
        act = { action: 6, label: 'Download do XML' }
        this.moreActions.push(act)
        act = { action: 3, label: 'Cancelar NF-e' }
        this.moreActions.push(act)
      }
      if ((this.nf.stnf == '00') || (this.nf.stnf == '03')) {
        act = { action: 5, label: 'Excluir NF-e' }
        this.moreActions.push(act)
      }

      act = { action: 30, label: 'Eventos NF-e' }
      this.moreActions.push(act)

      // if (this.nf.stnf == '00' && this.nf.import_errors == 0) {
      //     this.concluirImport = true
      // }
    },

    downloadXML() {
      //visualizacao do XML da NFE
      var data = { codnf: this.nf.codnf, chave: this.nf.chave, tipo: 'NFE' }
      apiDownload(this, 'print/xmlnfe/', data, 'post')
    },

    async loadData() {
      var vm = this
      this.textocorrecao_anterior = ''

      //carrega a nf para alteracao ou visualizacao
      await this.$store.dispatch('loadNf_impnfe', { id: this.codnf })
      if (this.$store.getters.getNf) {
        this.nf = { ...this.$store.getters.getNf[0] }
        this.nfit = this.nf.nfit
        if (this.nf.nfpar) {
          this.nfpar = this.nf.nfpar
        }
        let validation = JSON.parse(this.nf.validation)
        if (this.nf.validation && validation.errmessages) {
          this.errmessages = validation
        } else {
          this.errmessages = []
        }
        this.moreActions = []
        this.updateActions()
        //carrega o texto da ultima correcao efetuada se houver
        let nfev = this.nf.nfev
        for (let i = 0; i < nfev.length; i++) {
          if (nfev[i].tpeventonfe == 'R') {
            this.textocorrecao_anterior = nfev[i].texto
          }
        }
        vm.unwatch = false
        for (let i = 0; i < this.nfit.length; i++) {
          vm.unidadeItemChange(i);
        }
        vm.unwatch = true
      }

      // checa se é uma importação de XML ou se houver itens a identificar
      this.showFormImportXML = (this.importXml || this.nf.import_xml > 0)
      if (this.showFormImportXML) {
        this.activeTab = 0
      }
      if (this.nf.import_errors > 0) {
        this.$scrollTo(0)
        this.$erpToastError('Por favor corrija os erros em destaque para esta nota fiscal')
      }

      //HABILITAR WATCH
      setTimeout(function () {
        vm.unwatch = false
      }, 1000)

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    changeTab(idx) {
      //mudança de pagina
      this._nf = this.nf
      this.activeTab = idx
    },

    nfparVlrChange(index) {
      //evento de controle de alteracao do valor da parcela
      //quando usuario alterar o valor de uma parcela, refaz as demais parcelas
      if (this.nf.parcelas <= 1) {
        return
      }
      let vlrparcial = 0
      let vlrnovaparcela = 0
      for (var x = 0; x <= index; x++) {
        vlrparcial = vlrparcial + parseFloat(this.nfpar[x].vlr)
      }
      if (vlrparcial < this.nf.totger) {
        vlrnovaparcela = (this.nf.totger - vlrparcial) / (this.nf.parcelas - (index + 1))
        vlrnovaparcela.toFixed(2)
      } else {
      }
      for (var x = index + 1; x <= this.nfpar.length - 1; x++) {
        this.nfpar[x].vlr = vlrnovaparcela
      }
    },

    async handleChangeCFOP(index) {
      if (this.nf.cfop_natureza[index].codnates != null) {
        await this.$store.dispatch('loadNates', { id: this.nf.cfop_natureza[index].codnates })
        this.nf.cfop_natureza[index].cfopentrada = this.selectedNates.cfop
      }
    },

    handleArmazenarEntrada() {
      this.$modalForm(true)
      this.excluirArmazenamento = false
      this.showFormEstoqueEntrada = true
    },

    closeArmazenarForm() {
      this.$modalForm(false)
      this.showFormEstoqueEntrada = false
      this.codnf = this.nf.codnf
      this.loadData()
    },

  },

  watch: {
    parcelas: function () {
      //calcula numero de parcelas da condicao de pagamento

      if (this.unwatch) {
        return
      }

      this.nfpar = [];
      let vlr = 0
      if (this.nf.parcelas == '0') {
        let parcela = { ...this.$store.getters.getEntities.nfpar }
        parcela.dtv = this.nf.data
        parcela.vlr = this.nf.totger
        parcela.obspar = ''
        this.nfpar.push(parcela)
      } else {
        for (var x = 1; x <= this.nf.parcelas; x++) {
          let parcela = { ...this.$store.getters.getEntities.nfpar }
          parcela.dtv = this.$addMonths(this.nf.data, x)
          parcela.dias = x * 30
          vlr = this.nf.totger
          vlr = arr(vlr / this.nf.parcelas, 2, true)
          // console.log('parcela ' + x + ': ' + vlr)
          parcela.vlr = vlr
          parcela.obspar = ''
          this.nfpar.push(parcela)
        }
      }
    },

    codnates: function () {
      if (this.unwatch) {
        return
      }
      if (this.nf.codnates != null) {
        this.$store.dispatch('loadNates', { id: this.nf.codnates })
      }
    },

    //DESABILITADO QUANDO ENTROU A DIGITACAO DE NATUREZA PARA CADA CFOP
    // selectedNates: function () {
    //     //AO SELECIONAR UMA NATUREZA
    //     if (this.unwatch) {
    //         return
    //     }

    //     this.nf.nates = this.selectedNates
    //     this.nf.cfop = this.nf.nates.cfop
    //     if (this.nf.nates && (this.nf.nates.tpnf == 'P' || this.nf.nates.tpnf == 'A' || this.nf.nates.tpnf == 'D')) {
    //         this.showNfRef = true
    //     } else {
    //         this.showNfRef = false
    //         this.nfref = []
    //     }
    // },

    selectedItem: function () {
      //quando alterar um item, carrega a unidade de medida e a lista de unidades de medida
      if (this.unwatch) return
      if (!this.selectedItem.length) return

      this.nfit[this.changedItemIdx].uni = this.selectedItem[0].uni
      this.nfit[this.changedItemIdx].item = this.selectedItem
    },

  },

  created() {
    this.metadata.nf.parcelas.options.sort(function (a, b) { return (Number(a.id) > Number(b.id)) ? 1 : ((Number(b.id) > Number(a.id)) ? -1 : 0); })

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })

    //this.crudText = this.$crudText(this.crud)

    if (this.$route.params && this.$route.params.id) {
      //this.codpedv = this.$route.params.id //numero do pedido de venda
      // this.handleFaturar() //fatura o pedido
      //carrega a nf para alteracao
      this.codnf = this.$route.params.id
      this.loadData()
      this.view = this.crud == SysVars.crudView

    }
    else
      if (this.crud == SysVars.crudI) {  //se for uma inclusao
        if (this.params.outrasSaidas) {
          this.nf.emissaopropria = 'S'
          this.nf.operacaonf = 'E'
          if (this.params.entradaArmazenamento) {
            this.nf.entradaarmazenamento = 'S'
          }
          this.nfOutrasSaidas = true
          this.formIncluir = true
        }
      } else {
        //carrega a nf para alteracao
        this.codnf = this.params.codnf
        this.loadData()
        this.view = this.crud == SysVars.crudView
      }

  }

}

</script>

<template>
  <div>
    <!-- FORMULARIO PRINCIPAL -->
    <div class="default-container">
      <div>
        <!-- BARRA SUPERIOR DE TITULOS E BOTOES -->
        <div class="row">
          <div class="col-md-6 col-12">
            <h4 class="def-title"> {{ title }}
            </h4>
          </div>
          <div class="col-md-6 col-12">
            <div class="float-right">
              <v-button label="Retornar" title="" icon="fa-arrow-left" @click="closeForm"></v-button>
              <v-button v-show="moreActions.length > 0" label="Mais Ações" @click="handleActions"
                :actions="moreActions"></v-button>
            </div>
          </div>
        </div>

        <validation class="mt-3" v-if="errmessages.errmessages" title="Erros de validação"
          :messages="errmessages.errmessages"></validation>
      </div>

      <!-- DADOS INICIAIS DA IMPORTACAO DO XML -->
      <div v-show="showFormImportXML">
        <div class="row col mb-2 align-items-center">
          <span class="lbl-title-produto" style="font-size: 24px; padding: 5px; background-color: #f0f0f0">{{ nf.serie
          }}</span>
          <span class="lbl-title-produto" style="font-size: 24px; padding: 5px; background-color: #f0f0f0">{{ nf.nf
          }}</span>
        </div>

        <div class="row col">
          <span v-if="nf.stnf == '00'" class="badge badge-orange mr-2">{{ nf.stnf | getTextOption(metadata.nf.stnf)
          }}</span>
          <span v-if="nf.stnf == '01'" class="badge badge-blue mr-2">{{ nf.stnf | getTextOption(metadata.nf.stnf)
          }}</span>
          <span v-if="nf.stnf == '10' || nf.stnf == '11'" class="badge badge-green mr-2">{{ nf.stnf |
              getTextOption(metadata.nf.stnf)
          }}</span>
          <span v-if="nf.stnf >= '50'" class="badge badge-red mr-2">{{ nf.stnf | getTextOption(metadata.nf.stnf)
          }}</span>
          <span v-if="nf.entradaarmazenamento == 'S'" class="badge badge-gray mr-2">Entrada Armazenamento</span>
          <span v-if="nf.emissaopropria == 'S'" class="badge badge-yellow mr-2">Nota Fiscal Própria</span>
          <!-- <span v-if="ambienteNFe" class="badge badge-red">NF-e em ambiente de homologação</span> -->
        </div>
        <hr>

        <!-- dados da nf -->
        <div class="row align-items-center">
          <div class="col-md-2 col-3">
            <v-label :metadata-field="metadata.nf.data"></v-label><br>
            <strong class="lbl">{{ nf.data | formatData }}</strong>
          </div>
          <div class="col-md-2 col-3">
            <v-label :metadata-field="metadata.nf.totger"></v-label><br>
            <strong class="lbl">{{ this.nf.totger | formatValue(2) }}</strong>
          </div>
          <div class="col-md-3 col-6">
            <v-label :metadata-field="metadata.nf.chave"></v-label><br>
            <strong class="lbl" style="white-space: initial !important; word-break: break-all !important;"> {{ nf.chave
            }}
            </strong>
          </div>
        </div>
        <hr>
        <label-title title="Organização" icon="fa-university"></label-title>
        <div class="row col mb-2">
          <input-part ref="part" :disabled="true" v-model="nf.codpart"></input-part>
        </div>
        <hr>
        <div class="row mb-2">
          <form-field v-model="nf.dtent" type="date" col="2" :metadata="metadata.nf.dtent" name="dtent"
            :v-errors="errors" v-validate="metadata.nf.dtent.validator" :disabled="isView"></form-field>
          <form-field v-model="nf.finalidade" type="select" col="4" :metadata="metadata.nf.finalidade" name="finalidade"
            :v-errors="errors" v-validate="metadata.nf.finalidade.validator" :disabled="isView"></form-field>
          <form-field v-if="nf.tpnf === 'CR'" v-model="nf.tpnfcredito" type="select" col="4" :metadata="metadata.nf.tpnfcredito" name="tpnfcredito" :v-errors="errors" v-validate="'required'" :disabled="isView"></form-field>
          <form-field v-if="nf.tpnf === 'DB'" v-model="nf.tpnfdebito" type="select" col="4" :metadata="metadata.nf.tpnfdebito" name="tpnfdebito" :v-errors="errors" v-validate="'required'" :disabled="isView"></form-field>
          <!-- <form-field v-model="nf.codnates" type="select2" col="4" :metadata="metadata.nf.codnates"
                        :select2="{entity: 'nates/entrada', minlength: 0}"
                        name="codnates" :v-errors="errors" v-validate="metadata.nf.codnates.validator"></form-field>
                    <form-field v-model="nf.cfop" type="select2" col="6" :metadata="metadata.nf.cfop"
                        :select2="{entity: 'cfop/entradas', minlength: 0}"
                        name="cfop" :v-errors="errors" v-validate="metadata.nf.cfop.validator"></form-field> -->
          <!-- <form-field v-model="nf.codnatfin" type="select2" col="6" :metadata="metadata.nf.codnatfin"
                        name="codnatfin" :v-errors="errors" v-validate="metadata.nf.codnatfin.validator"></form-field>
                    <form-field v-model="nf.coddeposito" type="select2" col="6" :metadata="metadata.nf.coddeposito"
                        name="coddeposito" :v-errors="errors" v-validate="metadata.nf.coddeposito.validator"></form-field> -->
        </div>
        <div class="row mb-2" v-for="(cfop, index) in nf.cfop_natureza" :index="index">
          <div class="col-md-12 col-12">
            <span class="lbl-edit">Selecione uma natureza para a CFOP {{ cfop.cfop }} </span>
          </div>
          <form-field v-model="cfop.codnates" type="select2" col="4" :metadata="metadata.nf.codnates"
            :select2="{ entity: 'nates/entrada', minlength: 0 }" :name="'codnates' + index" :v-errors="errors"
            v-validate="metadata.nf.codnates.validator" @input="handleChangeCFOP(index)" :disabled="isView">
          </form-field>
          <form-field v-model="cfop.cfopentrada" type="select2" col="4" :metadata="metadata.nf.cfop"
            :select2="{ entity: 'cfop/entradas', minlength: 0, maxWidth: '200px' }" :name="'cfop' + index"
            :v-errors="errors" v-validate="metadata.nf.cfop.validator" :disabled="isView"></form-field>
        </div>

        <!-- NOTAS REFERENCIADAS - USUARIO DIGITA INFORMAÇÕES -->
        <nf-form-ref v-if="showNfRef" :nfref="nfref" nf="nf"></nf-form-ref>

      </div>
    </div>
    <br>
    <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab"></tabs>
    <br>

    <div class="default-container" v-show="activeTab == 0">
      <!-- ITENS DO XML DE ENTRADA PARA IDENTIFICACAO -->
      <!-- <label-title title="Itens da Nota de Entrada"></label-title><br> -->
      <alert v-if="this.nfit.length == 0" type="info" text="Esta nota fiscal não possui itens."></alert>
      <div>
        <!-- <div v-if="this.nf.import_errors > 0" class="col">
                    <div class="alert alert-success fade show" role="alert">
                        Efetue abaixo o relacionamento dos itens da nota de entrada
                    </div>
                </div> -->
      </div>
      <div class="">
        <div class="mainbox" v-for="(it, index) in nfit" v-bind:key="it.itnf">
          <!-- <div v-if="it.nfitx[0].stitx == '1'" class="mark-red"></div>
                    <div v-if="it.nfitx[0].stitx != '1'" class="mark-green"></div> -->
          <div class="box">
            <div class="row align-items-center">
              <div class="col-md-12 col-12" v-if="it.nfitx[0].msg">
                <div class="alert alert-danger fade show" role="alert">
                  <span>{{ it.nfitx[0].msg }}</span>
                </div>
              </div>
              <div class="col-md-10 d-flex justify-content-between align-items-end p-0">
                <form-field v-model="it.coditem" type="select2" col="6" :metadata="metadata.nfit.coditem" name="coditem"
                  :v-errors="errors" v-validate="metadata.nfit.coditem.validator" :add-button="true"
                  @clickAdd="handleIncluirItem(index)" @input="itemChange(index)" :disabled="isView"></form-field>
                <form-field v-model="it.qtuni" type="value" col="2" :metadata="metadata.nfit.qtuni" name="qtuni"
                  :v-errors="errors" v-validate="metadata.nfit.qtuni.validator" :disabled="isView"></form-field>
                <form-field v-model="it.uni" type="select2" col="2" :metadata="metadata.nfit.uni" name="uni"
                  :v-errors="errors" v-validate="metadata.nfit.uni.validator" :add-button="true"
                  @clickAdd="handleIncluirUnimed(index)" @input="unidadeItemChange(index)" :disabled="isView">
                </form-field>
                <form-field v-show="it.obrigaFator" v-model="it.fator" type="value" col="2"
                  :metadata="metadata.nfit.fator" name="fator" :v-errors="errors"
                  v-validate="metadata.nfit.fator.validator" :disabled="isView"></form-field>
              </div>
              <div class="col-md-2">
                <span v-show="it.coditem == null || it.coditem == ''" class="error">
                  <i class="fa fa-unlink nb-icon-link" aria-hidden="true" data-toggle="tooltip" data-placement="top"
                    title="Produto ainda não foi vinculado, ao Confirmar Nota de Entrada o produto será automaticamente cadastrado no sistema."></i>
                </span>
                <span v-show="it.coditem != '' && it.coditem != null">
                  <i class="fa fa-check nb-icon-ok pt-4" aria-hidden="true"></i>
                </span>
              </div>
            </div>
            <!-- <div class="row">
                            <div class="col-md-2 col-3">
                                <v-label class="lbl-edit-sm" :metadata-field="metadata.nfitx.codigoxml"></v-label><br>
                                <span class="data-list-sm">{{ it.nfitx[0].codigoxml }}</span>
                            </div>
                            <div class="col-md-6 col-6">
                                <v-label class="lbl-edit-sm" :metadata-field="metadata.nfitx.descricao"></v-label><br>
                                <span class="data-list-sm">{{ it.nfitx[0].descricao }}</span>
                            </div>
                            <div class="col-md-2 col-3">
                                <v-label class="lbl-edit-sm" :metadata-field="metadata.nfitx.qt"></v-label><br>
                                <span class="data-list-sm">{{ it.nfitx[0].qt | format(4) }} {{ it.nfitx[0].uni }}</span>
                            </div>
                            <div class="col-md-2 col-3">
                                <v-label class="lbl-edit-sm" :metadata-field="metadata.nfitx.vlr"></v-label><br>
                                <span class="data-list-sm">{{ it.nfitx[0].vlr | format(4) }}</span>
                            </div>
                        </div> -->
            <!-- <div class="row mb-2">
                            <div class="col text-center">
                                <a style="cursor: pointer; color: #0091ea;" @click="showTotal = true"><i class="fa fa-caret-down" aria-hidden="true"></i> Detalhar</a>
                            </div>
                        </div> -->
            <div class="row m-3" style="background: #f7f7f7">
              <div class="col-12 mb-3">
                <strong class="data-list-sm"
                  style="white-space: initial !important; word-break: break-all !important;">{{
                      it.nfitx[0].descricao
                  }}</strong>
              </div>
              <div class="col-md-2 col-12">
                <v-label class="lbl-edit-sm" style="white-space: initial !important; word-break: break-all !important;"
                  :metadata-field="metadata.nfitx.codigoxml"></v-label><br>
              </div>
              <div class="col-md-2 col-12">
                <span class="data-list-sm">{{ it.nfitx[0].codigoxml }}</span>
              </div>
              <div class="col-md-2 col-12 d-md-block d-none">
                <v-label class="lbl-edit-sm" label="CFOP"></v-label><br>
              </div>
              <div class="col-md col-12 d-md-block d-none">
                <span class="data-list-sm">{{ it.nfitx[0].cfop }}</span>
              </div>
              <div class="col-md-2 col-12 d-md-block d-none" v-if="it.item[0]">
                <v-label class="lbl-edit-sm" label="Uni. Item Cadastro"></v-label><br>
              </div>
              <div class="col-md col-12 d-md-block d-none" v-if="it.item[0]">
                <span class="data-list-sm">{{ it.item[0].uni }}</span>
              </div>

              <div class="w-100"></div>
              <div class="col-md-2 col-12">
                <v-label class="lbl-edit-sm" :metadata-field="metadata.nfitx.qt"></v-label><br>
              </div>
              <div class="col-md-2 col-12">
                <span class="data-list-sm">{{ it.nfitx[0].qt | format(4) }} {{ it.nfitx[0].uni }}</span>
              </div>
              <div class="col-md-2 col-12">
                <v-label class="lbl-edit-sm" :metadata-field="metadata.nfitx.vlr"></v-label><br>
              </div>
              <div class="col-md-2 col-12">
                <span class="data-list-sm">{{ it.nfitx[0].vlr | format(4) }}</span>
              </div>
              <div class="w-100"></div>
              <div class="col-2 d-md-block d-none">
                <v-label class="lbl-edit-sm" :metadata-field="metadata.nfit.sticm"></v-label><br>
              </div>
              <div class="col d-md-block d-none">
                <span class="data-list-sm">{{ it.sticm }}</span>
              </div>
              <div class="col-2 d-md-block d-none">
                <v-label class="lbl-edit-sm" :metadata-field="metadata.nfit.vicm"></v-label><br>
              </div>
              <div class="col d-md-block d-none">
                <span class="data-list-sm">{{ it.aicm | format(2) }} %</span>
                <span class="data-list-sm">R$ {{ it.vicm | format(2) }}</span>
              </div>
              <div class="w-100"></div>
              <div class="col-2 d-md-block d-none">
                <v-label class="lbl-edit-sm" :metadata-field="metadata.nfit.vicmst"></v-label><br>
              </div>
              <div class="col d-md-block d-none">
                <span class="data-list-sm">{{ it.aicmst | format(2) }} %</span>
                <span class="data-list-sm">R$ {{ it.vicmst | format(2) }}</span>
              </div>
              <div class="col-2 d-md-block d-none">
                <v-label class="lbl-edit-sm" :metadata-field="metadata.nfit.vipi"></v-label><br>
              </div>
              <div class="col d-md-block d-none">
                <span class="data-list-sm">{{ it.aipi | format(2) }} %</span>
                <span class="data-list-sm">R$ {{ it.vipi | format(2) }}</span>
              </div>
              <div class="w-100"></div>
              <div class="col-2 d-md-block d-none">
                <v-label class="lbl-edit-sm" :metadata-field="metadata.nfit.vpis"></v-label><br>
              </div>
              <div class="col d-md-block d-none">
                <span class="data-list-sm">{{ it.apis | format(2) }} %</span>
                <span class="data-list-sm">R$ {{ it.vpis | format(2) }}</span>
              </div>
              <div class="col-2 d-md-block d-none">
                <v-label class="lbl-edit-sm" :metadata-field="metadata.nfit.vcofins"></v-label><br>
              </div>
              <div class="col d-md-block d-none">
                <span class="data-list-sm">{{ it.acofins | format(2) }} %</span>
                <span class="data-list-sm">R$ {{ it.vcofins | format(2) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FIM DE DADOS INICIAIS DA IMPORTACAO DO XML -->




    <!-- <nfsaida-item v-if="showFormItem" :params="paramItem"
            @closeform="closeFormItem" @save="saveItem"></nsaida-item> -->


    <!-- TOTALIZACAO DA NOTA FISCAL -->
    <div class="default-container" id="formCab" v-show="formCab || activeTab == 3">
      <div class="col">
        <label-title title="Totalização da Nota"></label-title>
        <div class="row">
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.totipi"></v-label><br>
            <span class="lbl">{{ nf.totipi | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.totii"></v-label><br>
            <span class="lbl">{{ nf.totii | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.vcredsn"></v-label><br>
            <span class="lbl">{{ nf.vcredsn | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.tottrib"></v-label><br>
            <span class="lbl">{{ nf.tottrib | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.totmer"></v-label><br>
            <span class="lbl">{{ nf.totmer | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.totger"></v-label><br>
            <span class="lbl">{{ nf.totger | format(2) }}</span>
          </div>
        </div>
        <hr>
        <label-title title="Despesas"></label-title>
        <div class="row">
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.vlrfre"></v-label><br>
            <span class="lbl">{{ nf.vlrfre | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.vlrseg"></v-label><br>
            <span class="lbl">{{ nf.vlrseg | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.vlrdesp"></v-label><br>
            <span class="lbl">{{ nf.vlrdesp | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.totdes"></v-label><br>
            <span class="lbl">{{ nf.totdes | format(2) }}</span>
          </div>
        </div>
        <hr>
        <label-title title="ICMS"></label-title>
        <div class="row">
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.bcicm"></v-label><br>
            <span class="lbl">{{ nf.bcicm | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.toticm"></v-label><br>
            <span class="lbl">{{ nf.toticm | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.totfcp"></v-label><br>
            <span class="lbl">{{ nf.totfcp | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.bcicmst"></v-label><br>
            <span class="lbl">{{ nf.bcicmst | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.toticmst"></v-label><br>
            <span class="lbl">{{ nf.toticmst | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.totfcpst"></v-label><br>
            <span class="lbl">{{ nf.totfcpst | format(2) }}</span>
          </div>
        </div>
        <hr>
        <label-title title="DIFAL"></label-title>
        <div class="row">
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.toticmemit"></v-label><br>
            <span class="lbl">{{ nf.toticmemit | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.toticmdest"></v-label><br>
            <span class="lbl">{{ nf.toticmdest | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.totfcpdest"></v-label><br>
            <span class="lbl">{{ nf.dest | format(2) }}</span>
          </div>
        </div>
        <hr>
        <label-title title="PIS e COFINS"></label-title>
        <div class="row">
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.bcpis"></v-label><br>
            <span class="lbl">{{ nf.bcpis | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.totpis"></v-label><br>
            <span class="lbl">{{ nf.totpis | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.totpisst"></v-label><br>
            <span class="lbl">{{ nf.totpisst | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.bccofins"></v-label><br>
            <span class="lbl">{{ nf.bccofins | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.totcofins"></v-label><br>
            <span class="lbl">{{ nf.totcofins | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.totcofinsst"></v-label><br>
            <span class="lbl">{{ nf.totcofinsst | format(2) }}</span>
          </div>
        </div>
        <hr>
        <label-title title="Retenções"></label-title>
        <div class="row">
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.vretcsll"></v-label><br>
            <span class="lbl">{{ nf.vretcsll | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.vretirrf"></v-label><br>
            <span class="lbl">{{ nf.vretirrf | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.vretinss"></v-label><br>
            <span class="lbl">{{ nf.vretinss | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.vretpis"></v-label><br>
            <span class="lbl">{{ nf.vretpis | format(2) }}</span>
          </div>
          <div class="col-md-4 col-4">
            <v-label :metadata-field="metadata.nf.vretcofins"></v-label><br>
            <span class="lbl">{{ nf.vretcofins | format(2) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- OUTROS DADOS DA NOTA FISCAL -->
    <div class="default-container" v-show="activeTab == 1">
      <div class="row">
        <form-field v-model="nf.movest" type="select" col="2" :metadata="metadata.nf.movest" :disabled="true">
        </form-field>
        <form-field v-model="nf.movterc" type="select" col="2" :metadata="metadata.nf.movterc" :disabled="true">
        </form-field>
        <form-field v-model="nf.creicm" type="select" col="2" :metadata="metadata.nf.creicm" :disabled="true">
        </form-field>
        <form-field v-model="nf.creipi" type="select" col="2" :metadata="metadata.nf.creipi" :disabled="true">
        </form-field>
        <form-field v-model="nf.crepis" type="select" col="2" :metadata="metadata.nf.crepis" :disabled="true">
        </form-field>
        <form-field v-model="nf.crecofins" type="select" col="2" :metadata="metadata.nf.crecofins" :disabled="true">
        </form-field>
      </div>
      <label-title title="Transporte"></label-title><br>
      <div class="row">
        <form-field v-model="nf.tpfrete" type="select" col="4" :metadata="metadata.nf.tpfrete" :disabled="true">
        </form-field>
        <form-field v-model="nf.codparttr" type="select2" col="4" :metadata="metadata.nf.codparttr" :disabled="true">
        </form-field>
        <form-field v-model="nf.placa" type="text" col="2" :metadata="metadata.nf.placa" :disabled="true"></form-field>
        <form-field v-model="nf.placauf" type="text" col="2" :metadata="metadata.nf.placauf" :disabled="true">
        </form-field>
        <form-field v-model="nf.vlrfre" type="value" col="2" :metadata="metadata.nf.vlrfre" :disabled="true">
        </form-field>
        <form-field v-model="nf.vlrseg" type="value" col="2" :metadata="metadata.nf.vlrseg" :disabled="true">
        </form-field>
        <form-field v-model="nf.vlrdesp" type="value" col="2" :metadata="metadata.nf.vlrdesp" :disabled="true">
        </form-field>
        <form-field v-model="nf.pliq" type="value" col="2" :metadata="metadata.nf.pliq" :disabled="true"></form-field>
        <form-field v-model="nf.pbru" type="value" col="2" :metadata="metadata.nf.pbru" :disabled="true"></form-field>
        <form-field v-model="nf.qtvolumes" type="value" col="2" :metadata="metadata.nf.qtvolumes" :disabled="isView">
        </form-field>
      </div>

      <label-title title="Informações Complementares"></label-title><br>
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="form-group">
            <v-label :metadata-field="metadata.nf.obs"></v-label>
            <span class="data-list">{{ nf.obs }}</span>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-group">
            <v-label :metadata-field="metadata.nf.obsfisco"></v-label>
            <span class="data-list">{{ nf.obsfisco }}</span>
          </div>
        </div>
      </div>
      <label-title title="Retenções de Tributos"></label-title><br>
      <div class="row">
        <form-field v-model="nf.vretcsll" type="value" col="2" :metadata="metadata.nf.vretcsll" :disabled="true">
        </form-field>
        <form-field v-model="nf.pretpis" type="value" col="2" :metadata="metadata.nf.pretpis" :disabled="true">
        </form-field>
        <form-field v-model="nf.vretpis" type="value" col="2" :metadata="metadata.nf.vretpis" :disabled="true">
        </form-field>
        <form-field v-model="nf.pretcofins" type="value" col="2" :metadata="metadata.nf.pretcofins" :disabled="true">
        </form-field>
        <form-field v-model="nf.vretcofins" type="value" col="2" :metadata="metadata.nf.vretcofins" :disabled="true">
        </form-field>
        <form-field v-model="nf.pretinss" type="value" col="2" :metadata="metadata.nf.pretinss" :disabled="true">
        </form-field>
        <form-field v-model="nf.vretinss" type="value" col="2" :metadata="metadata.nf.vretinss" :disabled="true">
        </form-field>
        <form-field v-model="nf.pretirrf" type="value" col="2" :metadata="metadata.nf.pretirrf" :disabled="true">
        </form-field>
        <form-field v-model="nf.vretirrf" type="value" col="2" :metadata="metadata.nf.vretirrf" :disabled="true">
        </form-field>
      </div>
    </div>
    <!-- FIM OUTROS DADOS -->



    <!-- DADOS DE PAGAMENTO -->
    <div class="default-container" id="formPar" v-show="activeTab == 2">
      <label-title title="Pagamento"></label-title><br>
      <div v-if="selectedNates && selectedNates.calcdup != 'S'">
        <alert type="info" text="A natureza atribuída à esta nota fiscal não permite informar parcelas."></alert>
      </div>
      <div v-if="selectedNates && selectedNates.calcdup == 'S'">
        <div class="row">
          <div class="col-md-4 col-6">
            <form-field v-model="nf.codnatfin" type="select2" col="12" :metadata="metadata.nf.codnatfin"
              name="codnatfin" :v-errors="errors" v-validate="metadata.nf.codnatfin.validator"
              :select2="{ entity: 'natfin/despesas/', minlength: 0 }"></form-field>
          </div>
          <div class="col-md-4 col-6">
            <div class="form-group">
              <v-label :metadata-field="metadata.nf.parcelas"></v-label>
              <select class="form-control form-control-sm" name="parcelas" v-model="nf.parcelas">
                <option v-for="opt in metadata.nf.parcelas.options" :key="opt.id" :value="opt.id">{{ opt.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <br>
        <div class="row justify-content-md-center">
          <div class="col-md-2 col-3">
            <v-label :metadata-field="metadata.nfpar.dias"></v-label>
          </div>
          <div class="col-md-2 col-3">
            <v-label :metadata-field="metadata.nfpar.dtv"></v-label>
          </div>
          <div class="col-md-2 col-3">
            <v-label :metadata-field="metadata.nfpar.vlr"></v-label>
          </div>
        </div>
        <div class="row justify-content-md-center" v-for="(par, index) in nfpar" :key="index">
          <form-field v-model="par.dias" type="number" col="2" :disabled="isView || nf.parcelas === '0'" name="dias"
            :v-errors="errors" v-validate="metadata.nfpar.dias.validator" @input="nfparDiasChange(index)"></form-field>
          <form-field v-model="par.dtv" type="date" col="2" :disabled="isView" name="dtv" :v-errors="errors"
            v-validate="metadata.nfpar.dtv.validator"></form-field>
          <form-field v-model="par.vlr" type="value" col="2" :precision="2" :disabled="isView" name="vlr"
            :v-errors="errors" v-validate="metadata.nfpar.vlr.validator" @input="nfparVlrChange(index)"></form-field>
        </div>
      </div>
    </div>
    <!-- FIM DADOS DE PAGAMENTO -->


    <div v-if="entradaArmazenamentoPendente">
      <alert type="info" title="Nota Pendente de Armazenamento" :text="entradaArmazenamentoPendente"></alert>
    </div>
    <div class="row mt-2">
      <div class="col-md-12 col-12">
        <v-button label="Confirmar Nota de Entrada" title="Conclui a digitação da nota fiscal de entrada"
          :nb-btdef="true" icon="fa-check" @click="handleConcluirImportXml"></v-button>
        <v-button v-if="entradaArmazenamentoPendente" label="Armazenar Nota" title="" icon=""
          @click="handleArmazenarEntrada"></v-button>
      </div>
    </div>


    <!-- CADASTRO DO ITEM  -->
    <div class="nb-modal-scrollable" v-if="showItemForm">
      <div class="container nb-modal-scrollable-container" style="max-width: 700px">
        <div id="mymodal" class="nb-modal-scrollable-body">
          <item-form :crud="crudItem" :import-xml="paramsCadastro" v-on:closeform="closeItemForm"></item-form>
        </div>
      </div>
    </div>


    <!-- CADASTRO DA UNIDADE DE MEDIDA  -->
    <div class="nb-modal-scrollable" v-if="showUnimedForm">
      <div class="container nb-modal-scrollable-container" style="max-width: 700px">
        <div id="mymodal" class="nb-modal-scrollable-body mb-3">
          <unimed-form :crud="crudItem" :import-xml="paramsCadastro" v-on:closeform="closeUnimedForm"></unimed-form>
        </div>
      </div>
    </div>


    <!-- ARMAZENAMENTO DA NOTA DE ENTRADA -->
    <div class="nb-modal-scrollable" v-if="showFormEstoqueEntrada">
      <div class="nb-modal-scrollable-container" style="padding: 15px; width: 90%">
        <div class="nb-modal-scrollable-body">
          <estoque-entrada :index="nf.codnf" :excluir="excluirArmazenamento" @closeform="closeArmazenarForm">
          </estoque-entrada>
        </div>
      </div>
    </div>


    <nfe-eventos-form v-if="showEventos" :nf="nf" @close="showEventos = false" @success="loadData"></nfe-eventos-form>


  </div>
</template>

<style>
.nb-icon-link {
  font-size: 32px;
  color: red;
  text-align: center;

}

.nb-icon-ok {
  font-size: 32px;
  color: greenyellow;
}
</style>






// WEBPACK FOOTER //
// src/forms/nfentrada-form.vue